import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsIntegrationsService} from '../../../services/settings-integrations.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-integrations-list',
    templateUrl: './settings-integrations-list.component.html',
    styleUrls: ['./settings-integrations-list.component.scss']
})
export class SettingsIntegrationsListComponent {

    constructor(
        public urlService: UrlService,
        public settingsIntegrationsService: SettingsIntegrationsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsIntegrationsService.data.allSettingsAmenities.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.uncheckItem();
        if (checked && this.settingsIntegrationsService.selectedItemData) {
            selectedItem.checked = false;
            this.settingsIntegrationsService.toggleDetailedView(null, false);
        } else {
            selectedItem.checked = true;
            this.settingsIntegrationsService.selectedItemData = null;
            setTimeout(() => {
                this.settingsIntegrationsService.toggleDetailedView(selectedItem, true);
            });
        }
    }

    uncheckItem(): void {
        this.settingsIntegrationsService.data.allSettingsAmenities.data.forEach((item) => item.checked = false);
    }

    deleteAmenity(item, event): void {
        event.stopPropagation();
        this.settingsIntegrationsService.deleteAmenity(item);
    }

    getBuildingNameById(id): string {
        let name = '';

        this.settingsIntegrationsService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    goToAppsList() {
        this.settingsIntegrationsService.isAppsListShow = true;
        this.settingsIntegrationsService.showListView = false;
        this.settingsIntegrationsService.getData();
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations-list/settings-integrations-list.component.ts